export const ESTABLISHMENT_INTERNAL_ORDER_STATUS_DRAFT = "DRAFT";
export const ESTABLISHMENT_INTERNAL_ORDER_STATUS_SUBMITTED = "SUBMITTED";
export const ESTABLISHMENT_INTERNAL_ORDER_STATUS_CONFIRMED = "CONFIRMED";
export const ESTABLISHMENT_INTERNAL_ORDER_STATUS_PARTIALLY_INVOICED =
  "PARTIALLY_INVOICED";
export const ESTABLISHMENT_INTERNAL_ORDER_STATUS_COMPLETED = "COMPLETED";
export const ESTABLISHMENT_INTERNAL_ORDER_STATUS_REJECTED = "REJECTED";
export const ESTABLISHMENT_INTERNAL_ORDER_STATUS_CANCELED = "CANCELED";

export const establishmentInternalOrderStatuses = [
  ESTABLISHMENT_INTERNAL_ORDER_STATUS_DRAFT,
  ESTABLISHMENT_INTERNAL_ORDER_STATUS_SUBMITTED,
  ESTABLISHMENT_INTERNAL_ORDER_STATUS_CONFIRMED,
  ESTABLISHMENT_INTERNAL_ORDER_STATUS_PARTIALLY_INVOICED,
  ESTABLISHMENT_INTERNAL_ORDER_STATUS_COMPLETED,
  ESTABLISHMENT_INTERNAL_ORDER_STATUS_REJECTED,
  ESTABLISHMENT_INTERNAL_ORDER_STATUS_CANCELED,
];

export const ESTABLISHMENT_INTERNAL_ORDER_INVOICING_STATUS_PENDING = "PENDING";
export const ESTABLISHMENT_INTERNAL_ORDER_INVOICING_STATUS_PARTIALLY_INVOICED =
  "PARTIALLY_INVOICED";
export const ESTABLISHMENT_INTERNAL_ORDER_INVOICING_STATUS_INVOICED =
  "INVOICED";

export const establishmentInternalOrderInvoicingStatuses = [
  ESTABLISHMENT_INTERNAL_ORDER_INVOICING_STATUS_PENDING,
  ESTABLISHMENT_INTERNAL_ORDER_INVOICING_STATUS_PARTIALLY_INVOICED,
  ESTABLISHMENT_INTERNAL_ORDER_INVOICING_STATUS_INVOICED,
];

/**
 * Statuses in which the order may still receive internal invoices — mirrors
 * EstablishmentInternalOrder::INVOICEABLE_STATUSES on the API side.
 */
export const establishmentInternalOrderInvoiceableStatuses = [
  ESTABLISHMENT_INTERNAL_ORDER_STATUS_CONFIRMED,
  ESTABLISHMENT_INTERNAL_ORDER_STATUS_PARTIALLY_INVOICED,
];

/**
 * Document-level rebate ("rabais") types — mirrors App\Constants\Discounts.
 */
export const DISCOUNT_TYPE_AMOUNT = "AMOUNT";
export const DISCOUNT_TYPE_PERCENTAGE = "PERCENTAGE";

export const discountTypes = [DISCOUNT_TYPE_PERCENTAGE, DISCOUNT_TYPE_AMOUNT];
